export default __webpack_public_path__ + "static/media/ENG. MECATR.f06ff866.pdf";